import { useState, useEffect } from 'react'
import {
  Box,
  CircularProgress,
  Grid,
  Paper,
  Typography,
} from '@material-ui/core'

import FinancialDataBarChart from './components/FinancialDataBarChart'
import FiscalYearDropdown from '../../common/FiscalYearDropdown/components/FiscalYearDropDown'
import FinancialDataTotalOverview from './components/FinancialDataTotalOverview'

import ApiGetBudgetOverview from './api/apiBudgetOverview'

export const BudgetOverview = ({ coproId, endPoint = 'middleoffice' }) => {
  const apiBudgetOverview = new ApiGetBudgetOverview()

  const [filteredFiscalYears, setFilteredFiscalYear] = useState([])
  const [selectedFiscalYearId, setSelectedFiscalYearId] = useState(null)

  const [financialData, setFinancialData] = useState([])

  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const fetchBudgetFinancialData = async () => {
      setIsLoading(true)

      if (selectedFiscalYearId) {
        let res = await apiBudgetOverview.getBudgets(
          coproId,
          selectedFiscalYearId,
          endPoint
        )

        if (!Array.isArray(res)) {
          res = []
        }
        setFinancialData(res)
      }

      setIsLoading(false)
    }

    fetchBudgetFinancialData()
  }, [coproId, selectedFiscalYearId])

  useEffect(() => {
    const fetchFiscalYears = async () => {
      const res = await apiBudgetOverview.getFiscalYears(coproId, endPoint)

      if (res && res.length > 0) {
        const localFilteredFiscalYear = res.filter(
          (item) =>
            item.status === 'current' ||
            (item.rgddKeys && item.rgddKeys.length > 0)
        )

        // Set current year in FisclYears as default
        const currrentFiscalYear = localFilteredFiscalYear.find(
          (fy) => fy.status === 'current'
        )

        setFilteredFiscalYear(localFilteredFiscalYear)

        if (currrentFiscalYear) {
          setSelectedFiscalYearId(currrentFiscalYear.id)
        }
      }
    }

    fetchFiscalYears()
  }, [])

  return (
    <Box sx={{ padding: '25px' }} component={Paper}>
      <Grid>
        <Box
          display="content"
          flexDirection="column"
          alignItems="center"
          style={{ marginBottom: '25px' }}
        >
          <Box alignSelf="flex-start" style={{ marginBottom: '-70px' }}>
            <Typography style={{ fontSize: '18px', marginBottom: '10px' }}>
              Choix de l&apos;exercice
            </Typography>
            <FiscalYearDropdown
              fiscalYears={filteredFiscalYears}
              selectedFiscalYearId={selectedFiscalYearId}
              onFiscalYearDropDownChange={(fiscalYearId) => {
                setSelectedFiscalYearId(fiscalYearId)
              }}
            />
          </Box>
          <Box style={{ minHeight: '180px' }}>
            <FinancialDataTotalOverview financialData={financialData} />
          </Box>
        </Box>

        {isLoading ? (
          <Grid
            item
            xs={12}
            style={{
              minHeight: '500px',
              background: 'white',
              fontSize: '24px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            Chargement des budgets...
            <CircularProgress style={{ marginTop: '25px' }} />
          </Grid>
        ) : (
          <FinancialDataBarChart financialData={financialData} />
        )}
      </Grid>
    </Box>
  )
}

export default BudgetOverview
